import { environment } from '../../../environments/environment';

export function isAdminEmail(email?: string | null): boolean {
  const adminEmail = environment.admin_email?.toLowerCase();
  return !!email && !!adminEmail && email.toLowerCase() === adminEmail;
}

export function resolveLoginEmail(
  userProfile?: { email?: string } | null,
  cognitoUser?: { username?: string } | null,
): string | undefined {
  return userProfile?.email || cognitoUser?.username;
}

export function isAdminUser(
  userProfile?: { email?: string } | null,
  cognitoUser?: { username?: string } | null,
): boolean {
  return isAdminEmail(resolveLoginEmail(userProfile, cognitoUser));
}
